import axios from 'axios'
import authHeader from '../security/auth.header'

const API_URL = process.env.VUE_APP_BASE_API_URL + '/api/v1/admin/pos-devices'

class PosDeviceApi {
  getList(page, size) {
    return axios.get(API_URL + '?actualPage=' + page + '&perPage=' + size, {
      headers: authHeader()
    })
  }
}

export default new PosDeviceApi()
